

import clover from './images/clover.png'
import diamond from './images/diamond.png'
import heart from './images/heart.png'
import spade from './images/spade.png'

export const values = ['A', '2', '3', '4', '5', '6', '7', '8', '9', '10', 'J', 'Q', 'K']
export const suits = { clover, diamond, heart, spade }